import { Box, BoxProps, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { ReactComponent as CheckmarkIcon } from 'app/assets/svg/checkmark.svg'
import {
  lowerCaseRegex,
  numberRegex,
  specialCharactersRegex,
  upperCaseRegex,
} from 'app/utils/Regex'
import { useTheme } from '@mui/material/styles'

type RequirmentProps = {
  text: string
  valid: boolean
}

const Requirment = ({ valid, text }: RequirmentProps) => {
  const { palette } = useTheme()
  const color = valid ? palette.success.main : palette.grey[500]
  return (
    <Box display="flex" alignItems={'center'} mb={0.3}>
      <CheckmarkIcon color={color} />
      <Typography style={{ marginLeft: 8 }}>{text}</Typography>
    </Box>
  )
}

interface Props extends BoxProps {
  password: string
}

function PasswordRequirements(props: Props) {
  const { password = '', ...rest } = props
  const {
    containsUpperCase,
    containsLowerCase,
    containsNumber,
    containsSpecialCharacter,
    validLength,
  } = useMemo(() => {
    return {
      containsUpperCase: upperCaseRegex.test(password),
      containsLowerCase: lowerCaseRegex.test(password),
      containsNumber: numberRegex.test(password),
      containsSpecialCharacter: specialCharactersRegex.test(password),
      validLength: password?.length >= 12 && password?.length <= 128,
    }
  }, [password])
  return (
    <Box {...rest}>
      <Typography gutterBottom><strong>Password requirements:</strong></Typography>
      <Requirment
        valid={containsUpperCase}
        text={'At least one uppercase character'}
      />
      <Requirment
        valid={containsLowerCase}
        text={'At least one lowercase character'}
      />
      <Requirment valid={containsNumber} text={'At least one number'} />
      <Requirment
        valid={containsSpecialCharacter}
        text={'At least one special character'}
      />
      <Requirment valid={validLength} text={'Minimum 12 characters'} />
    </Box>
  )
}

export default React.memo(PasswordRequirements)
